import { createApp } from 'vue'
import store        from './store'
import ItsTimeBlock from "@/components/News/ItsTimeBlock";
import SwitherTheme         from "@/components/News/SwitherTheme";
import SwitcherThemeEllipse from "@/components/News/SwitcherThemeEllipse";
import CollectionMainPage from "@/components/News/CollectionMainPage";
import CollectionDetail from "@/components/News/CollectionDetail";
import FormCallBack       from "@/components/Forms/FormCallBack";
import ItstimeSectionList from "@/components/Section/ItstimeSectionList";
import FormOrder from "@/components/Forms/FormOrder";
import FormAsk  from "@/components/Forms/FormAsk";
import WhereBuy from "@/components/News/Where-Buy";


document.addEventListener("DOMContentLoaded", ()=>{
    const app = createApp({
        data() {
            return {
                //theme: localStorage.getItem('color-scheme'),
                theme: 'brown',
                //loader: false
            }
        },
        components: {
            ItsTimeBlock,
            SwitherTheme,
            SwitcherThemeEllipse,
            CollectionMainPage,
            CollectionDetail,
            FormCallBack,
            ItstimeSectionList,
            FormOrder,
            FormAsk,
            WhereBuy
        },

        mounted() {
            //console.log('mounted vue!');
            if(!localStorage.getItem('color-scheme'))
                {
                    this.theme = 'brown';
                }
            else
                {
                    this.theme = localStorage.getItem('color-scheme');
                }

            window.initUI();
            // this.$nextTick(function () {
            //     const html = document.querySelector('html')
            //     html.classList.remove();
            //     html.classList.add('theme');
            //     html.classList.add(this.theme);
            // })
            //console.log(window.location.pathname);
            if(window.location.pathname === "/collection/")
                {
                    window.location.href = window.location.pathname + this.theme + "/"
                }
            if(window.location.pathname === "/recipes/")
                {
                    window.location.href = window.location.pathname + this.theme + "/"
                }

        },
        methods:
            {
                changeTheme(color) {
                    this.theme = color;
                    document.cookie = "theme="+this.theme + "; path=/; max-age=86400;";
                    //console.log(localStorage.getItem('color-scheme'));

                }
            }
    });

    app.use(store);
    app.mount('#app');
});


